import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';

export default class CardTypesFilter extends Component {
    static propTypes = {
        filter: PropTypes.any,
        onChange: PropTypes.func
    };

    render() {
        return (
            <select
                className="filter-input"
                onChange={(event) => this.props.onChange(event.target.value)}
                value={get(this.props, 'filter.value', '')}
            >
                <option value="">ALL</option>
                <option value="10">VISA</option>
                <option value="20">MASTERCARD</option>
                <option value="30">DISCOVER</option>
                <option value="40">AMEX</option>
            </select>
        );
    }
}
